import get from "lodash/get"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"

export const verifyCustomerAccountLink = (data, errorCb) => () => {
  const api = `VERIFY_ACCOUNT`
  const template = URITemplate(urls.url[api])
  const url = template.expand({
    customerId: data?.customerId,
    lang: data?.lang,
  })

  const rawToken = data?.token || ""
  const safeToken = rawToken

  const config = {
    headers: {
      token: safeToken,
      apiKey: get(urls, `apiKey.USER[${api}]`, ``),
    },
  }

  const postRequestData = {
    userId: data?.userId,
    approvalStatus: data?.approvalStatus?.toUpperCase(), // Can be “Approved” or “Rejected”
  }

  return axios
    .create(config)
    .post(url, postRequestData)
    .then((response) => response)
    .catch((error) => {
      const status = error?.response?.status
      return errorCb(error, status)
    })
}
